import { apiEndpoint } from 'configs'
import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'

export const getDetailPayable = createAsyncThunk(
  'payable/detail',
  async ({ id }, { rejectWithValue, getState }) => {
    try {
      const { auth } = getState()
      let config = {
        headers: {
          Authorization: `Bearer ${auth.token}`,
        },
      }
      const { data } = await axios.get(
        `${apiEndpoint}/api/v1/bussines/payable/${id}`,
        config,
      )

      return data
    } catch (error) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message)
      } else {
        return rejectWithValue(error.message)
      }
    }
  },
)

export const getDetailPayablePersonal = createAsyncThunk(
  'payable/detailPersonal',
  async ({ id }, { rejectWithValue, getState }) => {
    try {
      const { auth } = getState()
      let config = {
        headers: {
          Authorization: `Bearer ${auth.token}`,
        },
      }
      const { data } = await axios.get(
        `${apiEndpoint}/api/v1/bussines/personal-payable/${id}`,
        config,
      )

      return data
    } catch (error) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message)
      } else {
        return rejectWithValue(error.message)
      }
    }
  },
)


export const getPendingPayable = createAsyncThunk(
  'payable/pending',
  async (_, { rejectWithValue, getState }) => {
    try {
      const { auth } = getState()
      let config = {
        headers: {
          Authorization: `Bearer ${auth.token}`,
        },
      }
      const { data } = await axios.get(
        `${apiEndpoint}/api/v1/bussines/payable/pending`,
        config,
      )

      return data
    } catch (error) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message)
      } else {
        return rejectWithValue(error.message)
      }
    }
  },
)

export const getPendingPayablePersonal = createAsyncThunk(
  'payable/pendingPersonal',
  async (_, { rejectWithValue, getState }) => {
    try {
      const { auth } = getState()
      let config = {
        headers: {
          Authorization: `Bearer ${auth.token}`,
        },
      }
      const { data } = await axios.get(
        `${apiEndpoint}/api/v1/bussines/personal-payable-pending`,
        config,
      )

      return data
    } catch (error) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message)
      } else {
        return rejectWithValue(error.message)
      }
    }
  },
)


export const getUsersFilterArap = createAsyncThunk(
  'arap/usersFilter',
  async ({ type }, { rejectWithValue, getState }) => {
    try {
      const { auth } = getState()

      const size = 50
      let page = 0
      let allItems = []
      let hasMore = true

      while (hasMore) {
        const { data } = await axios.get(
          `${apiEndpoint}/api/v1/bussines/payable/users`,
          {
            headers: {
              Authorization: `Bearer ${auth.token}`,
            },
            params: { type, size, page },
          },
        )

        allItems = allItems?.concat(data.items)

        if (data.items.length < size) {
          hasMore = false
        } else {
          page++
        }
      }

      const mappedItems = allItems?.map((e) => ({
        label: e?.name,
        value: e?.name,
        ...e,
      }))

      return mappedItems
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message)
    }
  },
)

export const getUsersFilterArapPersonal = createAsyncThunk(
  'arap/usersFilterPersonal',
  async ({ type }, { rejectWithValue, getState }) => {
    try {
      const { auth } = getState()

      const size = 50
      let page = 0
      let allItems = []
      let hasMore = true

      while (hasMore) {
        const { data } = await axios.get(
          `${apiEndpoint}/api/v1/bussines/personal-payable-users`,
          {
            headers: {
              Authorization: `Bearer ${auth.token}`,
            },
            params: { type, size, page },
          },
        )

        allItems = allItems?.concat(data.items)

        if (data.items.length < size) {
          hasMore = false
        } else {
          page++
        }
      }

      const mappedItems = allItems?.map((e) => ({
        label: e?.name,
        value: e?.name,
        ...e,
      }))

      return mappedItems
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message)
    }
  },
)
